import HttpRequest from './HttpRequest'
import { getAuthToken } from '@/utils/js/Auth'
export default class DealerProvider extends HttpRequest {
  getDealer (query) {
    this.setHeader(getAuthToken())
    return this.get(`/dealers?${query}`)
  }

  getDealerById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/dealers/${id}`)
  }

  getDealerLog(id, query) {
    this.setHeader(getAuthToken())
    return this.get(`/dealers/${id}/log?${query}`)
  }

  getDealerLogById(id) {
    this.setHeader(getAuthToken())
    return this.get(`/dealers/${id}/log-detail`)
  }

  createDealer (payload) {
    this.setHeader(getAuthToken())
    return this.post(`/dealers`, payload)
  }

  updateDealer (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/dealers/${id}`, payload)
  }

  deleteDealer (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/dealers?id=${id}`)
  }
}
